import { ObjectListRequestType, ObjectListResponseType } from '../ObjectListResponseTypes'

interface OrderListResponse extends ObjectListResponseType {
  orders: OrderResponse[]
}

interface OrderResponseInstallation {
  date: string
  type: string
  typeId: number
  status: string
  statusId: number
}

interface OrderResponseOption {
  optionId: number
  name: string
  statusId: number
  status: string
  subscriptionType: string
}
interface OrderResponse {
  orderId: number
  date: string
  description: string
  statusId: number
  status: string
  partner: string
  installations: OrderResponseInstallation[]
  options: OrderResponseOption[]
}

interface AddonResponse {
  success: boolean
  saleid: string
  errorMessage: string
  processedAt: string
}

interface OrderRequestBody extends ObjectListRequestType {}

const isOrderListResponse = (orderlist: any): orderlist is OrderListResponse => {
  if (orderlist === undefined) {
    return false
  }
  return 'orders' in orderlist
}
const isOrderResponse = (order: any): order is OrderResponse => {
  if (order === undefined) {
    return false
  }
  if (Array.isArray(order)) {
    return 'orderId' in order[0]
  }
  return 'orderId' in order
}
const isAddonResponse = (addon: any): addon is AddonResponse => {
  if (addon === undefined) {
    return false
  }
  return 'saleid' in addon && 'success' in addon
}
const isOrderRequestBody = (request: any): request is OrderRequestBody => {
  return true
  if (request === undefined) {
    return false
  }
  return 'statusid' in request
}

export type { OrderResponse, OrderRequestBody, OrderListResponse, AddonResponse }
export { isOrderResponse, isOrderRequestBody, isOrderListResponse, isAddonResponse }
